import ApplicationPlatform from './ApplicationPlatform'

export default ApplicationPlatform
